import type { Route } from 'vue-router';

// ID_066: where administrative users land when they open a route the backend would reject with 403.
export const ADMINISTRATIVE_FALLBACK_PATH = '/main/planning/calendar';

// Routes flagged with `meta.blockAdministrative` show patient health data or need eHealth,
// both of which the backend refuses for the administrative profile.
export const isBlockedForAdministrative = (route: Route) =>
  route.matched.some((record) => record.meta?.blockAdministrative === true);
